import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
import { Check, Gift, Lock } from 'lucide-react';
export function ValueStack() {
  const [mainExpired, setMainExpired] = useState(false);
  // Check on mount if the 24h timer already expired
  useEffect(() => {
    const startTime = localStorage.getItem('nutripeques-countdown-start');
    if (startTime) {
      const endTime = parseInt(startTime, 10) + 24 * 60 * 60 * 1000;
      if (Date.now() >= endTime) {
        setMainExpired(true);
      }
    }
  }, []);
  const stackItems = [{
    name: '📘 Guía de Fundamentos',
    value: '$15 USD'
  }, {
    name: '🌞 Mañanas con Energía (16 desayunos)',
    value: '$8 USD'
  }, {
    name: '🍲 Platos que Nutren (22 comidas)',
    value: '$12 USD'
  }, {
    name: '🍎 Snacks Inteligentes (12 meriendas)',
    value: '$8 USD'
  }, {
    name: '🎉 Gustitos Conscientes (10 recetas)',
    value: '$6 USD'
  }, {
    name: '📋 Sistema NutriPeques planificación semanal',
    value: '$10 USD'
  }, {
    name: '📊 Tabla de respuestas para conflictos en mesa',
    value: '$5 USD'
  }, {
    name: '💡 Tips de congelación y reutilización',
    value: '$4 USD'
  }];
  return <section id="oferta" className="py-20 px-4 bg-gradient-to-b from-[#FFF8F0] to-[#FFE0B2]/50" data-id="element-335">
      <div className="max-w-lg md:max-w-3xl mx-auto" data-id="element-336">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-[2rem] shadow-2xl overflow-hidden border-4 border-[#FF8A65] relative" data-id="element-337">
          {/* Header */}
          <div className="bg-[#FF8A65] text-white text-center py-6 px-4" data-id="element-338">
            <h2 className="text-2xl md:text-3xl font-black tracking-wide" data-id="element-339">
              🔥 OFERTA ESPECIAL DE LANZAMIENTO
            </h2>
          </div>

          <div className="p-6 md:p-10" data-id="element-340">
            {/* Stack List */}
            <div className="space-y-3 mb-8" data-id="element-341">
              {stackItems.map((item, idx) => <div key={idx} className="flex justify-between items-center border-b border-gray-100 pb-3" data-id="element-342">
                  <div className="flex items-center gap-2" data-id="element-343">
                    <Check className="w-5 h-5 text-[#4CAF50] shrink-0" data-id="element-344" />
                    <span className="text-gray-700 font-medium" data-id="element-345">
                      {item.name}
                    </span>
                  </div>
                  <span className="text-gray-400 line-through text-sm shrink-0 ml-4" data-id="element-346">
                    {item.value}
                  </span>
                </div>)}
              <div className="flex justify-between items-center bg-[#FFF3E0] p-3 rounded-xl border border-[#FFE0B2]" data-id="element-347">
                <div className="flex items-center gap-2" data-id="element-348">
                  <Gift className="w-5 h-5 text-[#E65100] shrink-0" data-id="element-349" />
                  <span className="text-[#E65100] font-bold" data-id="element-350">
                    Todas las actualizaciones futuras
                  </span>
                </div>
                <span className="text-[#E65100] font-black shrink-0 ml-4" data-id="element-351">
                  GRATIS
                </span>
              </div>
            </div>

            {/* Pricing Area */}
            <div className="bg-[#FDFBF7] rounded-2xl p-6 md:p-8 text-center border border-gray-200 mb-8 relative overflow-hidden" data-id="element-352">
              <div className="absolute top-0 right-0 bg-[#E65100] text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-353">
                {mainExpired ? '74% DE DESCUENTO' : '84% DE DESCUENTO'}
              </div>

              <div className="mb-2" data-id="element-354">
                <span className="text-gray-500 font-medium" data-id="element-355">Valor total: </span>
                <span className="text-gray-400 line-through text-lg" data-id="element-356">
                  $93 USD
                </span>
              </div>

              <div className="mb-4" data-id="element-357">
                <span className="text-gray-600 font-bold" data-id="element-358">
                  Precio regular:{' '}
                </span>
                <span className="text-gray-500 line-through text-xl" data-id="element-359">
                  $39 USD
                </span>
              </div>

              {/* Original $6.39 price — crossed out when expired */}
              <div className={`text-center mb-2 ${mainExpired ? 'opacity-50' : ''}`} data-id="element-360">
                <span className={`block text-sm font-bold uppercase tracking-wider mb-1 ${mainExpired ? 'text-gray-400' : 'text-[#4CAF50]'}`} data-id="element-361">
                  {mainExpired ? 'Oferta de lanzamiento expirada' : 'Oportunidad Única de Lanzamiento'}
                </span>
                <div className={`flex justify-center items-start gap-1 ${mainExpired ? 'line-through' : ''}`} data-id="element-362">
                  <span className={`text-3xl font-bold mt-2 ${mainExpired ? 'text-gray-400' : 'text-[#2E7D32]'}`} data-id="element-363">
                    $
                  </span>
                  <span className={`text-7xl md:text-8xl font-black leading-none ${mainExpired ? 'text-gray-400' : 'text-[#2E7D32]'}`} data-id="element-364">
                    6.39
                  </span>
                  <span className={`text-xl font-bold mt-2 ${mainExpired ? 'text-gray-400' : 'text-[#2E7D32]'}`} data-id="element-365">
                    USD
                  </span>
                </div>
              </div>

              {/* New $9.99 price — shown only when expired */}
              {mainExpired && <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-366">
                  <span className="block text-sm font-bold text-[#E65100] uppercase tracking-wider mb-1" data-id="element-367">
                    Precio especial por tiempo limitado
                  </span>
                  <div className="flex justify-center items-start gap-1" data-id="element-368">
                    <span className="text-3xl font-bold text-[#E65100] mt-2" data-id="element-369">
                      $
                    </span>
                    <span className="text-7xl md:text-8xl font-black text-[#E65100] leading-none" data-id="element-370">
                      9.99
                    </span>
                    <span className="text-xl font-bold text-[#E65100] mt-2" data-id="element-371">
                      USD
                    </span>
                  </div>
                </div>}
            </div>

            {/* Urgency — 24h countdown OR expired copy + 5min countdown */}
            {!mainExpired ? <div className="text-center mb-8" data-id="element-372">
                <p className="text-[#D84315] font-bold mb-2" data-id="element-373">
                  ⏰ Esta oferta desaparece en:
                </p>
                <CountdownTimer hours={24} storageKey="nutripeques-countdown-start" onExpire={() => setMainExpired(true)} data-id="element-374" />
                <p className="text-gray-500 text-sm mt-2" data-id="element-375">
                  Después el precio sube a $39 USD
                </p>
              </div> : <div className="text-center mb-8" data-id="element-376">
                <div className="bg-[#FFF3E0] rounded-2xl p-6 border border-[#FFE0B2] mb-6" data-id="element-377">
                  <p className="text-[#D84315] font-bold text-lg mb-4" data-id="element-378">
                    ⏰ La oferta de $6.39 ha expirado.
                  </p>
                  <p className="text-gray-700 mb-3" data-id="element-379">
                    Si sigues aquí es porque esto es para ti. Y lo sé.
                  </p>
                  <p className="text-gray-700 mb-3" data-id="element-380">
                    Así que por los próximos <strong data-id="element-381">5 minutos</strong> te
                    activo un precio especial de{' '}
                    <strong className="text-[#E65100]" data-id="element-382">$9.99 USD</strong>.
                  </p>
                  <p className="text-gray-700 mb-3" data-id="element-383">
                    Cuando este contador llegue a cero, el precio sube a{' '}
                    <strong data-id="element-384">$39.00 USD</strong> y ya no habrá más descuentos.
                  </p>
                  <p className="text-[#C62828] font-bold" data-id="element-385">
                    No es broma. No hay tercer contador. Toma esta oportunidad
                    ahora.
                  </p>
                </div>
                <CountdownTimer minutes={5} storageKey="nutripeques-countdown-5min" data-id="element-386" />
              </div>}

            {/* CTA — changes based on expired state */}
            <div className="flex flex-col items-center" data-id="element-387">
              {!mainExpired ? <>
                  <a href="https://pay.hotmart.com/T104716980E?off=3x8vd7e9&checkoutMode=10" className="w-full min-h-[72px] bg-[#4CAF50] hover:bg-[#388E3C] text-white text-xl md:text-2xl font-black rounded-2xl shadow-[0_8px_0_#2E7D32] hover:shadow-[0_4px_0_#2E7D32] hover:translate-y-1 transition-all flex items-center justify-center text-center px-4 py-4 mb-4" data-id="element-388">
                    → QUIERO EMPEZAR A NUTRIR CON CALMA
                  </a>
                  <p className="text-sm text-gray-500 font-medium flex flex-wrap justify-center gap-2 text-center" data-id="element-389">
                    <span data-id="element-390">Acceso inmediato</span>
                    <span className="hidden sm:inline" data-id="element-391">·</span>
                    <span data-id="element-392">Descarga directa</span>
                    <span className="hidden sm:inline" data-id="element-393">·</span>
                    <span data-id="element-394">Garantía total</span>
                  </p>
                </> : <>
                  <a href="https://pay.hotmart.com/T104716980E?off=e1tj7u2p&checkoutMode=10" className="w-full min-h-[72px] bg-[#E65100] hover:bg-[#BF360C] text-white text-xl md:text-2xl font-black rounded-2xl shadow-[0_8px_0_#BF360C] hover:shadow-[0_4px_0_#BF360C] hover:translate-y-1 transition-all flex items-center justify-center text-center px-4 py-4 mb-4 animate-pulse" data-id="element-395">
                    SÍ, QUIERO NUTRIPEQUES
                  </a>
                  <p className="text-sm text-gray-500 font-medium flex items-center justify-center gap-2 text-center" data-id="element-396">
                    <Lock className="w-4 h-4" data-id="element-397" />
                    <span data-id="element-398">
                      Pago seguro · Acceso inmediato · Garantía 7 días
                    </span>
                  </p>
                </>}
            </div>
          </div>
        </motion.div>

        <p className="text-center text-gray-600 italic mt-8 text-lg" data-id="element-399">
          "No necesitas hacerlo perfecto. Necesitas empezar."
        </p>
      </div>
    </section>;
}